import React, { useState, useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import "./css/App.css";
import OktaAuth from "@okta/okta-auth-js";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Body from "./containers/Body";
import config from "./libs/authConfig";
import LogIn from "./components/LogIn";
import Help from "./components/Help";
import { ToastProvider } from "react-toast-notifications";
import { Slide, Dialog } from "@material-ui/core";
import {
  updateForm,
  fetchProfile,
  fetchBaseProperty,
  testUserData,
  testCalculatorData,
  setAge1,
  setAge2,
  setBirthday1,
  setBirthday2,
  setTotalIncome,
  setNon401IraIncome,
  generateBudget,
  generateWages,
  generateSS,
  generatePrivatePension,
  generatePublicPension,
  setInvestmentIncome,
  generateShortfall,
  generateYears,
  setMarriedIncome,
  calculateNeeded,
} from "./state/calculator";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const authClient = new OktaAuth(config);

function App(props) {
  const [user, setUser] = useState("");
  const [totalUser, setTotalUser] = useState({});
  const [showSecondFiler, setShowSecondFiler] = useState(false);
  const [authenticated, setAuthenticated] = useState(false);
  const [openHelpModal, setOpenHelpModal] = useState(false);
  const {
    subjectS2,
    numSubS2,
    taxFileS2,
    justWagesS2,
    targetTaxableBudgetS2,
    birthdayS2,
    birthYearS2,
    ageS2,
    ageWagesStopS2,
    retireYearS2,
    retireAgeS2,
    planYearS2,
    ageYearS2,
    wagesS2,
    socialSecurityS2,
    pvtPensionS2,
    pvtPensionAgeS2,
    pubPensionS2,
    pubPensionAgeS2,
    k401S2,
    k401AgeS2,
    k401AnnuityS2,
    iraS2,
    iraAgeS2,
    iraAnnuityS2,
    annuityS2,
    healthInsS2,
    ageGroupS2,
  } = props.redux;

  const {
    targetTaxableBudgetS1,
    birthdayS1,
    ageS1,
    ageWagesStopS1,
    retireYearS1,
    retireAgeS1,
    wagesS1,
    socialSecurityS1,
    pvtPensionS1,
    pvtPensionAgeS1,
    pubPensionS1,
    pubPensionAgeS1,
    k401S1,
    k401AgeS1,
    iraS1,

    both,
  } = props.redux;

  useEffect(() => {
    props.testCalculatorData();
    props.generateBudget();
    props.setAge1();
    props.setTotalIncome();
    if (props.redux.both === true) {
      props.setAge2();
      props.setMarriedIncome();
      props.calculateNeeded();
    }
  }, []);

  useEffect(() => {
    props.generateBudget();
  }, [targetTaxableBudgetS1]);

  useEffect(() => {
    props.setAge1();
    props.setTotalIncome();
    if (props.redux.both === true) {
      props.setAge2();
      props.setMarriedIncome();
      props.calculateNeeded();
    }
  }, [
    ageS1,
    wagesS1,
    socialSecurityS1,
    pvtPensionS1,
    pubPensionS1,
    pvtPensionAgeS1,
    pubPensionAgeS1,
    iraS1,
    k401S1,
    ageWagesStopS1,
    k401AgeS1,
    retireAgeS1,
    targetTaxableBudgetS1,
    both,
    ageS2,
    wagesS2,
    socialSecurityS2,
    pvtPensionS2,
    pubPensionS2,
    pvtPensionAgeS2,
    pubPensionAgeS2,
    iraS2,
    k401S2,
    ageWagesStopS2,
    k401AgeS2,
    retireAgeS2,
    targetTaxableBudgetS2,
    birthdayS1,
    retireYearS1,
  ]);

  useEffect(() => {
    let status = localStorage.getItem("authenticated");
    let user = localStorage.getItem("user");
    let jsUser = JSON.parse(user);
    setTotalUser(jsUser);
    console.log(jsUser);

    if (status === "true") {
      setAuthenticated(true);
      let obj;
      let id;
      if (!jsUser.user) {
        obj = {
          id: "id",
          value: jsUser.id,
        };
        id = jsUser.id;
      } else {
        obj = {
          id: "id",
          value: jsUser.user.id,
        };
        id = jsUser.user.id;
      }
      props.updateForm(obj);
      let body = {
        user_token: id,
      };
      if (authenticated === true) {
        fetch(`http://${process.env.REACT_APP_STAGE}/user/id`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => response.text())
          .then((data) => {
            if (data.length < 25) {
              return data;
            } else {
              let parsedData = JSON.parse(data);
              props.fetchProfile(parsedData[0]);
            }
            return data;
          });
        fetch(`http://${process.env.REACT_APP_STAGE}/user/property/base`, {
          method: "POST",
          body: JSON.stringify(body),
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => response.text())
          .then((data) => {
            if (data.length < 25) {
              return data;
            } else {
              let parsedData = JSON.parse(data);
              props.fetchBaseProperty(parsedData);
            }
            return data;
          });
        if (props.redux.properties.length === 0) {
          fetch(`http://${process.env.REACT_APP_STAGE}/getuserproperties`, {
            method: "POST",
            body: JSON.stringify({
              user_token: id,
            }),
            headers: {
              "Access-Control-Allow-Origin": "*",
              // Accept: "application/json"
              "Content-Type": "application/json;charset=UTF-8",
            },
          })
            .then((response) => response.text())
            .then((data) => {
              if (data.length < 25) {
                return data;
              } else {
                let parsedData = JSON.parse(data);
                // console.log(parsedData);
                let obj = { id: "properties", value: parsedData };
                props.updateForm(obj);
              }
              return data;
            });
        }
        fetch(`http://${process.env.REACT_APP_STAGE}/property/fetch/ten`, {
          method: "POST",
          body: JSON.stringify({
            user_token: id,
          }),
          headers: {
            "Access-Control-Allow-Origin": "*",
            // Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => response.text())
          .then((data) => {
            if (data.length < 25) {
              return data;
            } else {
              let parsedData = JSON.parse(data);
              // console.log("10 yr: ", parsedData);
              let obj = { id: "tenYear", value: parsedData };
              props.updateForm(obj);
              localStorage.setItem("mock10", data);
            }
            return data;
          });

        fetch(`http://${process.env.REACT_APP_STAGE}/user/taxes/federal`, {
          method: "POST",
          body: JSON.stringify({
            user_token: id,
          }),
          headers: {
            "Access-Control-Allow-Origin": "*",
            // Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => response.text())
          .then((data) => {
            if (data.length < 25) {
              return data;
            } else {
              let parsedData = JSON.parse(data);
              let obj = { id: "federalTaxes", value: parsedData };
              props.updateForm(obj);
            }
            return data;
          });
        fetch(`http://${process.env.REACT_APP_STAGE}/user/taxes/state`, {
          method: "POST",
          body: JSON.stringify({
            user_token: id,
          }),
          headers: {
            "Access-Control-Allow-Origin": "*",
            // Accept: "application/json",
            "Content-Type": "application/json;charset=UTF-8",
          },
        })
          .then((response) => response.text())
          .then((data) => {
            if (data.length < 25) {
              return data;
            } else {
              let parsedData = JSON.parse(data);
              let obj = { id: "stateTaxes", value: parsedData };
              props.updateForm(obj);
            }
            return data;
          });
      }
    }
  }, [authenticated]);

  function logOut() {
    localStorage.setItem("authenticated", false);
    localStorage.clear();
    setAuthenticated(false);
  }

  const handleLogin = async (un, pw) => {
    if (un.length > 0 && pw.length > 0) {
      return authClient
        .signIn({
          username: un,
          password: pw,
        })
        .then(function (transaction) {
          if (transaction.status === "SUCCESS") {
            console.log("login success", transaction);
            setUser(transaction.user.id);
            setTotalUser(transaction);
            localStorage.setItem("authenticated", true);
            localStorage.setItem("user", JSON.stringify(transaction));
            setAuthenticated(!authenticated ? true : false);
            return true;
          } else {
            console.log("login error", transaction);
            throw new Error("login error");
          }
        });
    }
  };

  return (
    <div className="App">
      <Router>
        <React.Fragment>
          <Header logOut={logOut} auth={authenticated} />
        </React.Fragment>
        <React.Fragment>
          <ToastProvider>
            {authenticated ? (
              <Body
                appProps={{
                  authClient,
                  showSecondFiler,
                  setShowSecondFiler,
                  logOut,
                  user,
                  totalUser,
                }}
              />
            ) : (
              <LogIn
                handleLogin={handleLogin}
                unlock={() => setAuthenticated(true)}
                setUserInLogin={() => setTotalUser()}
              />
            )}
          </ToastProvider>
        </React.Fragment>
        {authenticated ? <Footer /> : null}
        {authenticated ? (
          <Dialog
            style={{
              margin: "auto",
            }}
            open={openHelpModal}
            TransitionComponent={Transition}
            disableBackdropClick={false}
            hideBackdrop={false}
            onClose={() => setOpenHelpModal(false)}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
          >
            <Help handleClose={() => setOpenHelpModal(false)} />
          </Dialog>
        ) : null}
      </Router>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    redux: state,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      testCalculatorData: () => testCalculatorData(),
      updateForm: (formData) => updateForm(formData),
      testUserData: () => testUserData(),
      setBirthday1: (params) => setBirthday1(params),
      setBirthday2: (params) => setBirthday2(params),
      setAge1: () => setAge1(),
      setAge2: () => setAge2(),

      setTotalIncome: () => setTotalIncome(),
      setMarriedIncome: () => setMarriedIncome(),
      setNon401IraIncome: () => setNon401IraIncome(),
      generateBudget: () => generateBudget(),
      generateWages: () => generateWages(),
      generateSS: () => generateSS(),
      generatePrivatePension: () => generatePrivatePension(),
      generatePublicPension: () => generatePublicPension(),
      setInvestmentIncome: () => setInvestmentIncome(),
      generateShortfall: () => generateShortfall(),
      generateYears: (years) => generateYears(years),
      calculateNeeded: () => calculateNeeded(),
      fetchProfile: (data) => fetchProfile(data),
      fetchBaseProperty: (data) => fetchBaseProperty(data),
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
